exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--relations__Lelc8{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.styles--relation__2XClc{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;max-width:500px;margin-top:5px}.styles--left__3l0FO{background:#8bc34a;padding:10px;border-radius:5px;-webkit-box-flex:1;-ms-flex:1 1 1px;flex:1 1 1px;word-break:break-word}.styles--right__avxrc{background:#2196f3;padding:10px;border-radius:5px;-webkit-box-flex:1;-ms-flex:1 1 1px;flex:1 1 1px;word-break:break-word}.styles--middle__YU5zt{width:47px;height:17px;margin:0 10px;padding-top:7px;-webkit-box-flex:0;-ms-flex:0 0 47px;flex:0 0 47px}\n", ""]);

// exports
exports.locals = {
	"relations": "styles--relations__Lelc8",
	"relation": "styles--relation__2XClc",
	"left": "styles--left__3l0FO",
	"right": "styles--right__avxrc",
	"middle": "styles--middle__YU5zt"
};